import { createHandlerChainRunnerOptionalParameter, Handler } from "@insite/client-framework/HandlerCreator";

export const ClearSearch: Handler = props => {
    props.dispatch({
        type: "Custom/RMA/ClearParameter",
    });
};

export const chain = [ClearSearch];

const clearRMASearch = createHandlerChainRunnerOptionalParameter(chain, {}, "clearRMASearch");
export default clearRMASearch;
